export default __webpack_public_path__ + "static/media/logo-color.1fea2819.png";